import styled from 'styled-components'
import { lightGrey12 } from '@edulastic/colors'

export const QuestionTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`
export const InlineMathEssayContainer = styled.div`
  width: ${({ reduceWidth }) => `calc(100% - ${reduceWidth})`};
  border-radius: 4px;
  position: relative;
  border-right: 1px solid ${lightGrey12};
  border-bottom: 1px solid ${lightGrey12};
  border-left: 1px solid ${lightGrey12};
`
